import * as React from 'react';
import { Button, StackLayout } from '@leagueplatform/genesis-core';
import { ErrorState } from '@leagueplatform/web-common-components';
import { Link } from 'react-router-dom';
import { useIntl } from '@leagueplatform/locales';

/** Values allowed by `formatMessage` when formatting a string (ICU placeholders). */
type ErrorPageHeadingValues = Record<
  string,
  string | number | boolean | null | undefined | Date
>;

interface ErrorPageProps {
  heading?: string;
  headingValues?: ErrorPageHeadingValues;
  homeUrl?: string;
  secondaryCta?: {
    label: string;
    to: string;
  };
}

export function ErrorPage({
  heading = 'SORRY_WE_CANT_FIND_PAGE',
  headingValues,
  homeUrl = '/',
  secondaryCta,
}: ErrorPageProps) {
  const { formatMessage } = useIntl();
  const headingText = formatMessage({ id: heading }, headingValues);
  const ctaTo = secondaryCta?.to ?? homeUrl;
  const ctaLabel = formatMessage({
    id: secondaryCta?.label ?? 'RETURN_HOME',
  });
  const error = {};
  return (
    <StackLayout
      css={{
        height: '100vh',
      }}
      horizontalAlignment="center"
      verticalAlignment="center"
      spacing="$one"
    >
      <ErrorState headingString={headingText} error={error} />
      <Button as={Link} to={ctaTo} priority="secondary">
        {ctaLabel}
      </Button>
    </StackLayout>
  );
}
